export default __webpack_public_path__ + "static/media/KOD0140-min.57fb6c02.webp";